import { RiAddBoxLine } from "@itandi/itandi-bb-ui";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import React from "react";
import { useFormContext } from "react-hook-form";
import type { DealConstructionEdit } from "~/models/DealConstruction";
import { toThousandSeparator } from "~/utils/CurrencySeparator";
import Styles from "./ConstructionForm.module.scss";

type Props = {
	disabled: boolean;
	onClickSubmit: (reInput: boolean) => void;
	type: "add" | "edit" | "add_modal";
};

export const ConstructionFormFooter: React.FC<Props> = ({
	type,
	onClickSubmit,
	disabled
}: Props) => {
	const { watch } = useFormContext<DealConstructionEdit>();
	const getButtonLabel = React.useCallback(() => {
		if (type === "add") return "追加";
		if (type === "edit") return "更新";
		return "続けて追加";
	}, [type]);
	const totalAmount = watch("totalAmount");
	return (
		<Flex>
			<Grid margin="8px" width="50%">
				{type === "add" || type === "edit" ? (
					<div className={Styles.TotalAmountView}>
						¥{toThousandSeparator(totalAmount)}
					</div>
				) : (
					<Button
						disabled={disabled}
						onClick={(): void => {
							onClickSubmit(false);
						}}
						variant="secondary"
						width="fill"
					>
						追加
					</Button>
				)}
			</Grid>
			<Grid alignItems="center" margin="8px" width="50%">
				<Button
					disabled={disabled}
					onClick={(): void => {
						onClickSubmit(type === "add_modal");
					}}
					startIcon={<RiAddBoxLine />}
					variant={type === "add_modal" ? "primary" : "secondary"}
					width="fill"
				>
					{getButtonLabel()}
				</Button>
			</Grid>
		</Flex>
	);
};
